/**
 * i18next bootstrap (react-i18next). Scaffold only — the catalog seeds the
 * `common` namespace; screen strings are extracted incrementally later (the
 * app is Spain-only today, so there's just one locale: `es`).
 *
 * Resources are bundled + initialised synchronously, so no async backend and
 * no React Suspense are needed; `useTranslation()` works on first render.
 * The active language comes from `DEFAULT_LOCALE` (locale-config.ts) — the
 * single seam for going multi-locale.
 *
 * Imported for side effect from `main.tsx` before the app renders. Typed keys
 * come from the module augmentation in `react-i18next.d.ts`.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE } from './locale-config'
import esCommon from './locales/es/common.json'

export const defaultNS = 'common'

export const resources = {
  es: { common: esCommon },
} as const

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE.language,
  fallbackLng: DEFAULT_LOCALE.language,
  defaultNS,
  ns: [defaultNS],
  resources,
  // React already escapes interpolated values — disable i18next's escaping
  // to avoid double-encoding.
  interpolation: { escapeValue: false },
  // Resources are bundled (sync) — no loading state, so skip Suspense.
  react: { useSuspense: false },
})

export default i18n
